<script setup lang="ts">
import type { GradeCode } from '~/models/Grade'
import { computed } from 'vue'
import { KsDropdown } from '@aschehoug/kloss'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import useFilterStore from '~/stores/filter'
import useProductStore from '~/stores/product'
import { useSubjectViewStore } from '~/stores/subjectView'
import { sortByGradeIndex } from '~/utils/gradeSorter'
import useSubjectsStore from '~/stores/subjects'

const { t } = useI18n()
const filterStore = useFilterStore()
const { selectedGrade } = storeToRefs(filterStore)
const { currentSubject } = storeToRefs(useSubjectsStore())
const { products } = storeToRefs(useProductStore())
const { productData } = storeToRefs(useSubjectViewStore())

const availableGradesBasedOnChosenSubject = computed<GradeCode[]>(() => {
  const gradeSet = new Set<GradeCode>() // using Set to avoid duplicate entries
  if (currentSubject.value) {
    products.value
      .filter((product) => product.subjects.length === 0 || product.subjects.includes(currentSubject.value as string))
      .forEach((product) => product.grades.forEach((grade) => gradeSet.add(grade)))
  }
  if (productData.value) {
    productData.value.forEach((product) => product.grades.forEach((grade) => gradeSet.add(grade)))
  }

  return [...gradeSet].sort(sortByGradeIndex) // converts set to Array and sorts by grades' indices
})

if (!selectedGrade.value) selectedGrade.value = availableGradesBasedOnChosenSubject.value[0]

</script>

<template>
  <KsDropdown
    v-model="selectedGrade"
    :options="availableGradesBasedOnChosenSubject"
    :option-id="(grade: GradeCode) => grade"
    :option-label="(grade: GradeCode) => t(`metadata.grades.${grade}`)"
    :placeholder="$t('filters.chooseGrade')"
    shape="rounded"
    autolabel
    :multiple="false"
    :deselectable="() => false"
    flexible
  />
</template>
